import {
  BlockStack,
  // Box,
  // InlineStack,
  // ProgressBar,
} from "@shopify/polaris";
import CommonTableFilterSkeletonList from "./CommonTableFilterSkeletonList";
const Index = () => {
  return (
    <div className="skeleton_page_children">
      <BlockStack gap="300" direction="cloumn">
        <CommonTableFilterSkeletonList />
      </BlockStack>
      </div>
  );
};

export default Index;
